import { Link } from "react-router-dom";

/* badge: optional count (e.g. unanswered complaints), hidden when 0 */
export const MenuItem = ({ category, title, icon, linkTo, handleClick, activeCategory, isBigMenu, badge }) => {
  const isActive = activeCategory === category;
  return (
    <Link
      to={linkTo}
      category={category}
      title={title}
      onClick={handleClick}
      className={`group flex items-center rounded-lg transition-colors duration-150 ${
        isBigMenu
          ? "gap-3 px-3 py-2.5 w-full"
          : "justify-center w-10 h-10 mx-auto"
      } ${
        isActive
          ? "bg-[var(--secondary-color)] text-white shadow-sm shadow-[var(--secondary-color)]/20"
          : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
      }`}
    >
      <span
        className={`relative shrink-0 inline-flex items-center justify-center ${
          isActive ? "text-white" : "text-gray-500 group-hover:text-gray-900"
        }`}
      >
        {icon}
        {!isBigMenu && badge > 0 && (
          <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-[var(--secondary-color)] text-white text-[10px] font-semibold leading-4 text-center tabular-nums">
            {badge > 99 ? "99+" : badge}
          </span>
        )}
      </span>
      {isBigMenu && (
        <span
          className={`text-[13px] truncate tracking-tight ${
            isActive ? "font-semibold" : "font-medium"
          }`}
        >
          {title}
        </span>
      )}
      {isBigMenu && badge > 0 && (
        <span
          title={`${badge} pa përgjigje`}
          className={`ml-auto shrink-0 min-w-[20px] h-5 px-1.5 rounded-full text-[11px] font-semibold leading-5 text-center tabular-nums ${
            isActive ? "bg-white text-[var(--secondary-color)]" : "bg-[var(--secondary-color)] text-white"
          }`}
        >
          {badge > 99 ? "99+" : badge}
        </span>
      )}
    </Link>
  );
};
